export const GENDER_VALUES = [
  "female",
  "male",
  "non_binary",
  "prefer_not_to_say",
] as const;

export type Gender = (typeof GENDER_VALUES)[number];

export const GENDER_OPTIONS: ReadonlyArray<{ value: Gender; label: string }> = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "non_binary", label: "Non-binary" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export function isGender(value: unknown): value is Gender {
  return (
    typeof value === "string" &&
    GENDER_VALUES.includes(value as Gender)
  );
}